import Card from "components/card";
import { useDealData } from "contexts/DealContext";
import PieChart from "./PieChart";

const PayerMixADC = () => {
  const { currentFacility, selectedPeriod } = useDealData();

  // Get occupancy data from the new structure
  const periodData = currentFacility?.periods?.[selectedPeriod]?.Categories || {};
  const occupancyData = periodData?.Occupancy || [];

  // Filter for day-related data
  const filteredData = occupancyData.filter(item => item.Type.includes("Day"));

  // Prepare chart data
  const chartLabels = filteredData.map(item => item.Type);
  const chartData = filteredData.map(item => Number(item.PPD));

  const pieChartOptions = {
    colors: [
      "#BFCAD2", "#2397EB", "#405F78", "#755263",
      "#40464B", "#f0b41c", "#445CAB", "#968148", "#48466B"
    ],
    fill: {
      colors: [
        "#BFCAD2", "#2397EB", "#405F78", "#755263",
        "#40464B", "#f0b41c", "#445CAB", "#968148", "#48466B"
      ],
    },
    labels: chartLabels,
    chart: {
      width: "50px",
      animations: {
        enabled: true,
        easing: "easeout",
        speed: 800,
      },
    },
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "center",
      labels: {
        colors: "#002A4B",
        useSeriesColors: false,
      },
      markers: {
        width: 12,
        height: 12,
        radius: 6,
        colors: undefined,
      },
      fontSize: "14px",
      fontFamily: "Inter, sans-serif",
    },
    dataLabels: {
      enabled: true,
      formatter: function (val, opt) {
        return `${val.toFixed(0)}%`;
      },
      offsetX: 0,
      style: {
        fontSize: "14px",
        fontWeight: "bold",
        colors: ["#fff"],
      },
      dropShadow: {
        enabled: false,
      },
    },
    plotOptions: {
      pie: {
        expandOnClick: true,
        dataLabels: {
          offset: 0,
          enabled: true,
          dropShadow: {
            enabled: false,
          },
        },
        donut: {
          size: "50%",
          labels: {
            show: true,
            name: {
              show: true,
              fontSize: "22px",
              fontFamily: "Inter",
              color: "#002A4B",
            },
            value: {
              show: true,
              fontSize: "16px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 400,
              color: "#002A4B",
              offsetY: 16,
            },
            total: {
              show: true,
              showAlways: true,
              label: "Total",
              fontSize: "20px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 600,
              color: "#373d3f",
              offsetY: -10,
              formatter: function () {
                return Math.floor(chartData.reduce((acc, val) => acc + val, 0));
              },
            },
          },
        },
      },
    },
    tooltip: {
      enabled: true,
      theme: "dark",
      style: {
        fontSize: "16px",
      },
    },
  };

  return (
    <div className="payer-mix h-full">
      <Card extra={"items-center w-full p-[16px] bg-cover"}>
        <h3 className="ml-6 mb-2 text-xl self-start font-bold text-gray-700 dark:text-white">
          Payer Mix ADC
        </h3>
        {occupancyData.length > 0 ? (
          <PieChart chartData={chartData} chartOptions={pieChartOptions} />
        ) : (
          <p className="text-gray-600 dark:text-gray-400">No data available</p>
        )}
      </Card>
    </div>
  );
};

export default PayerMixADC;